import { StoreAppAPI } from "../core/src/storeapp-api-client";
import { Helpers } from "../core/src/helpers";
import { receiveProducts } from "../product/product-actions";

export const TRACK_PAGE_VIEW = 'TRACK_PAGE_VIEW';
export const FETCH_SLUG_INFO = 'FETCH_SLUG_INFO';
export const RECEIVE_SLUG_INFO = 'RECEIVE_SLUG_INFO';
export const RECEIVE_ASYNC_COMPONENTS = 'RECEIVE_ASYNC_COMPONENTS';
export const RECEIVE_SLUG_ERROR = 'RECEIVE_SLUG_ERROR';
export const CLEAR_SLUG_ERROR = 'CLEAR_SLUG_ERROR';
export const ADD_REDIRECT = 'ADD_REDIRECT';
export const CLEAR_REDIRECTS = 'CLEAR_REDIRECTS';
export const RECEIVE_SITE_CONFIG = 'RECEIVE_SITE_CONFIG';

const storeAppAPI = new StoreAppAPI();

export const fetchingSlugInfo = () => ({
    type: FETCH_SLUG_INFO,
});

export const receiveSlugInfo = (slugInfo) => ({
    type: RECEIVE_SLUG_INFO,
    slugInfo
});

export const receiveSiteConfig = (siteConfig) => ({
    type: RECEIVE_SITE_CONFIG,
    siteConfig
});


/**
 * Tracking dispatch for metrics-middleware, this is to tigger page view metrics on hard load
 * Since the page data is stored in the inital redux store
 * @param {*} slugInfo 
 */
export const trackPageView = (slugInfo) => ({
    type: TRACK_PAGE_VIEW,
    slugInfo
});

export const receiveSlugError = () => ({
	type: RECEIVE_SLUG_ERROR
});

export const receiveAsyncComponents = (components) => ({
    type: RECEIVE_ASYNC_COMPONENTS,
    components
});

export const clearSlugError = () => ({
	type: CLEAR_SLUG_ERROR
});

export const addRedirect = (destination, status, isPGRedirect) => {
    return (dispatch, getState) => {
        const store = getState();
        const { routes } = store;
        dispatch({
            type: ADD_REDIRECT,
            destination,
            routes,
            status,
            isPGRedirect // not stored in redux but used in the metrics-middleware reducer
        });
    };
};

export const clearRedirects = () => ({
	type: CLEAR_REDIRECTS
});

const UXABTEST_MAP = {
	'sale-v3': 'sale-v4',
	'filters': 'filters-v2',
	'dlp': 'dlp-v2',
	'pdp': 'pdp-v2',
	'pdp-puf': 'pdp-v2',
	'blog': 'blog-v2'
}
export const processSlugInfo = (slugInfo, testFlags) => {
	let ids = [];
	let productObj = {};
	let defaultPg;
	let { templateKey, template_key, components=[] } = slugInfo;
	//TEMP AB test code
	const { defaultSort='recommended', ssrTest={} } = testFlags;
	const { uxRedesign } = ssrTest;

	//TODO: remove this backwards compatability changes
	slugInfo.templateKey = templateKey || template_key;
	slugInfo.components = components.reduce((map, comp) => {
		let { key } = comp;
		map[key] = comp;
		return map;
	},{});
	
	if(uxRedesign && uxRedesign.variation && uxRedesign.variation.toLowerCase() === 'variation'){
		let templateKey = UXABTEST_MAP[slugInfo.templateKey] || slugInfo.templateKey;
		//limit sale-v4 to weekly-deals and weekly-smb-deals
		if(templateKey !== 'sale-v4' || (slugInfo.key in { 'weekly_deals':1,'weekly_smb_deals':1,'presidents-day-sale':1})){
			slugInfo.templateKey = templateKey;
		}
	}
	let { productGroups=[] } = (slugInfo.components.productTab || {});
	
	productGroups.forEach(pg => {
		const { productsList, metaData, desc, name, key, disableIntelIcon } = pg;
		if(productsList) {
			let pgObj = {
				key,
				products: productsList,
				sortValue: 'rank.recommended',
				metaData: metaData,
				description: desc,
				name: name,
				disableIntelIcon
			};
			if(!defaultPg) defaultPg = key;
			//TEMP AB test code
			if(defaultSort === 'slp'){
				pgObj.products = Helpers.overrideDefaultSortOrder(pgObj.products,'recommended', defaultSort);
			}
			productObj[key] = pgObj;
			productsList.forEach(product => {
				if(product.prdClass !== "USER_DEFINED") {
					ids.push(product.itemId);
				}
			});
		}
	});
	slugInfo.defaultPg = defaultPg;

	return [ids, productObj, slugInfo];
}

const dispatchSlugInfo = (resp, dispatch, testFlags, router={}, hasRedirect) => {
    const [ids, productObj, slugInfo] = processSlugInfo(resp.data, testFlags);
    dispatch(receiveProducts(productObj));
    if(!hasRedirect){
        dispatch(clearRedirects());
    }
  const {location} = router;
  if(location) {
    const {search} = location;
    if(search) {
      slugInfo.urlParams = Helpers.getSearch(search);
    }
  }

	return dispatch(receiveSlugInfo(slugInfo));
}

export const fetchSlugInfo = (slug, options) => (dispatch, getState) => {
	//TEMP AB test code
	const store = getState();
	const { router, testFlags } = store;
	const { useGraphQL } = options;

	dispatch(fetchingSlugInfo());
	if(useGraphQL){
		return storeAppAPI.graphql.getPresistedQuery(slug,'sync').then(({ data: response }) => {
			const { page, seo } = response.data;
			const { pageComponents, globalComponents, ...rest } = page;
			dispatch(receiveSlugInfo({
				components: {
					...pageComponents,
					...globalComponents
				},
				seo,
				...rest
			}));
		});
	}
	return storeAppAPI.page.get(slug, options).then((resp) => {
		const { status } = resp.data;

		if ( status === 404 ) {
			dispatch(addRedirect(resp.data.destination, status));
			return dispatch(receiveSlugError());
		} else if ( status >= 300 &&  status < 400) {
			dispatch(addRedirect(resp.data.destination, status));
		} else if ( (resp.status * 1) === 200 ) {
            let hasRedirect = resp.data.redirectStatusCode && resp.data.destination;
            if(hasRedirect) dispatch(addRedirect(resp.data.destination, resp.data.redirectStatusCode, true));
            
            dispatchSlugInfo(resp, dispatch,  testFlags, router, hasRedirect);
        }
    }, err => {
        if( err.response && ((err.response.status >= 300 && err.response.status < 400) || (err.response.status === 404 && err.response.data.destination))){
			dispatch(addRedirect(err.response.data.destination, err.response.status));
        } else {
            dispatch(addRedirect());
        }
        return dispatch(receiveSlugError());
    })
}

export const fetchAsyncComponents = (slug, options) => (dispatch) => {
	return storeAppAPI.graphql.getPresistedQuery(slug,'async').then(({ data: response }) => {
		const { page } = response.data;
		const { pageComponents } = page;
		dispatch(receiveAsyncComponents(pageComponents));
	});
}

export const fetchSiteConfig = () => (dispatch) => {
	storeAppAPI.component
		.get(['siteConfig'])
		.then((resp) => {
			if (resp.status * 1 === 200) {
				const { data } = resp;
				dispatch(receiveSiteConfig(data))
			}
		})
}
